<template>
  <div id="app">
    <SiteHeader />
    <div class="main-body">
      <SiteHero />
      <SiteFeatures />
      <SitePricing />
      <SiteTutorial />
      <SiteDownload />
      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from './components/header.vue'
import SiteHero from './components/hero.vue'
import SiteFeatures from './components/features.vue'
import SitePricing from './components/pricing.vue'
import SiteTutorial from './components/tutorial.vue'
import SiteDownload from './components/download.vue'
import SiteFooter from './components/footer.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteHero,
    SiteFeatures,
    SitePricing,
    SiteTutorial,
    SiteDownload,
    SiteFooter
  }
}
</script>

<style>
:root {
  --primary: #4e8cff;
  --dark: #1a202c;
  --light: #f8fafc;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--dark);
  background: #fff;
}

#app {
}

.main-body {
  /* Header is fixed, give space */
  padding-top: 0;
}
</style>
